// @ts-expect-error React import required to render in Jira SSR
import React from 'react';
import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--jira-werewolves/jira-for-you-crossflow-solutions';

import { JsmOperationsRecommendationBanner } from '../../../components/JsmOperationsRecommendationBanner';

/**
 * The frontend stage receives the standard placement render props (including
 * `dismiss`). Per-tenant gating that depends on Jira `useResource()` data
 * (alerts/schedules empty, dismissal user property, JSM access) and the
 * primary CTA wiring to `<TeamEnablementWrapper>` are handled in the Jira-side
 * adapter that wraps this banner — they cannot live here because this package
 * must remain free of Jira-specific imports.
 */
export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<PlacementRenderProps>(),
		Component: ({ dismiss }: PlacementRenderProps) => (
			<JsmOperationsRecommendationBanner dismiss={dismiss} />
		),
	},
});
